"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SQS_DATE_PARSED_FORMAT = exports.SQS_DATE_SENT_FORMAT = exports.S3_PATH_DATE_FORMAT = void 0;
exports.S3_PATH_DATE_FORMAT = 'yyyyMMdd';
exports.SQS_DATE_SENT_FORMAT = 'yyyyMMdd HH:MM:ss';
exports.SQS_DATE_PARSED_FORMAT = 'yyyy-MM-dd HH:MM:ss';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXdzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy9hd3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRVUsUUFBQSxtQkFBbUIsR0FBRyxVQUFVLENBQUM7QUFDakMsUUFBQSxvQkFBb0IsR0FBRyxtQkFBbUIsQ0FBQztBQUMzQyxRQUFBLHNCQUFzQixHQUFHLHFCQUFxQixDQUFDIn0=